/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the typings and utility functions for the application theme
 * configuration.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Typings
 */
import { ThemeOptions, Theme } from '@material-ui/core/styles/createMuiTheme';

/** Typings */
import { TypographyOptions } from '@material-ui/core/styles/createTypography';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces / Types
 * ---------------------------------------------------------------------------------
 */

export interface IThemeOptions extends ThemeOptions {
    test?: string;
}

export interface ITheme extends Theme {
    test: string;
}

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

/**
 * This function selects the next (smaller) heading size.
 * @param currentRem current heading size.
 * @param minRem minimum allowed heading size.
 */
const createNextHeadingSize = (currentRem: number, minRem: number) => {
    const newRem = currentRem * 0.85;

    return newRem < minRem ? minRem : newRem;
}

/**
 * This function creates heading configuration for a theme.
 * @param h1Rem h1 size in REM
 * @param minRem minimum allowed heading size in REM
 */
export const createHeadingThemeSizes = (h1Rem: number, minRem?: number): TypographyOptions => {
    const minimum = minRem ? minRem : 1;

    const h2Rem = createNextHeadingSize(h1Rem, minimum);
    const h3Rem = createNextHeadingSize(h2Rem, minimum);
    const h4Rem = createNextHeadingSize(h3Rem, minimum);
    const h5Rem = createNextHeadingSize(h4Rem, minimum);
    const h6Rem = createNextHeadingSize(h5Rem, minimum);


    return {
        h1: {
            fontSize: `${h1Rem}rem`
        },
        h2: {
            fontSize: `${h2Rem}rem`
        },
        h3: {
            fontSize: `${h3Rem}rem`
        },
        h4: {
            fontSize: `${h4Rem}rem`
        },
        h5: {
            fontSize: `${h5Rem}rem`
        },
        h6: {
            fontSize: `${h6Rem}rem`
        }
    }
}


// WEBPACK FOOTER //
// ./src/style/theme/index.ts